﻿import { getInitDataRaw } from './telegram';

const BASE = `${import.meta.env.VITE_BACKEND_URL ?? ''}/api/app`;

if (!import.meta.env.VITE_BACKEND_URL) {
  console.error('VITE_BACKEND_URL is not configured. Please set it in .env.production or .env.local');
}

export class ApiError extends Error {
  constructor(public status: number, public body: string, public path: string) {
    super(`API ${status} on ${path}: ${body || '(empty)'}`);
    this.name = 'ApiError';
  }
}

export class NetworkError extends Error {
  constructor(
    public path: string,
    public cause: unknown,
    public context: {
      base: string;
      online: boolean;
      hasInitData: boolean;
      initDataLength: number;
    },
  ) {
    const causeText = cause instanceof Error ? cause.message : String(cause);
    super(
      `Network error on ${path}: ${causeText}. ` +
        `base=${context.base || '(empty)'} ` +
        `online=${context.online} ` +
        `initData=${context.hasInitData ? context.initDataLength + ' chars' : 'MISSING'}`,
    );
    this.name = 'NetworkError';
  }
}

export async function api<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const initData = getInitDataRaw();
  const url = `${BASE}${path}`;

  const customHeaders = new Headers(opts.headers);
  customHeaders.set('X-Telegram-Init-Data', initData);

  const hasBody = opts.body !== undefined && opts.body !== null;
  const isFormData = opts.body instanceof FormData;
  if (hasBody && !isFormData && !customHeaders.has('Content-Type')) {
    customHeaders.set('Content-Type', 'application/json');
  }

  let res: Response;
  try {
    res = await fetch(url, {
      ...opts,
      headers: customHeaders,
    });
  } catch (err) {
    const netErr = new NetworkError(path, err, {
      base: BASE,
      online: typeof navigator !== 'undefined' ? navigator.onLine : true,
      hasInitData: !!initData,
      initDataLength: initData.length,
    });
    console.error('[api] fetch failed', netErr.message, { cause: err });
    throw netErr;
  }

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(res.status, text, path);
  }

  const text = await res.text().catch(() => '');
  if (!text.trim()) return undefined as T;
  try {
    return JSON.parse(text) as T;
  } catch {
    return undefined as T;
  }
}
